export default function Resources() {
	return (
		<div className="container py-12">
			<h1 className="text-3xl font-bold">Resources</h1>
			<p className="mt-4 text-gray-600">FAQ, API docs, and integration guides to help you get started.</p>
		</div>
	);
}
